import { Search } from "@webapp/search/models/search.models";
import { MentionListUser, MentionPopoverUser } from "./mention-popover/mention-popover.models";

export const searchItemToMentionListUser = (user: Search<"users">): MentionListUser => ({
  id: user.id,
  value: user.fields.firstName + " " + user.fields.lastName,
  email: user.fields.auth0Cache.email,
  avatar: user.fields.auth0Cache.picture,
});

export const searchItemToMentionPopoverUser = (user: Search<"users">): MentionPopoverUser => ({
  id: user.id,
  firstName: user.fields.firstName,
  lastName: user.fields.lastName,
  email: user.fields.auth0Cache.email,
  picture: user.fields.auth0Cache.picture,
});
